import { axiosInstance } from '../common/api';

export const getUserProfile = async (userId, startDate = null, endDate = null) => {
  const url = `/profile/user/${userId}`;
  const params = {};

  // Add date range parameters if provided
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, { params })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const upsertUserProfile = async (userId, payload) => {
  const url = `/profile/user/${userId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, payload)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const createUserProfile = async (userId, payload) => {
  const url = `/profile/user/${userId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, payload)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export default {
  getUserProfile,
  upsertUserProfile,
  createUserProfile,
};


